import { useQuery } from '@tanstack/react-query'
import { emailQueryKeys, getSendingAddresses } from '../api/email.api'

const SENDING_ADDRESSES_STALE_TIME = 60_000

/**
 * What an email's From can be: Arvoke's address (under the organization's
 * name), the viewer's own at a sending domain, or one of the organization's
 * sending addresses (Settings > Email); and where replies to Arvoke's go.
 */
export function useSendingAddresses() {
  return useQuery({
    queryKey: emailQueryKeys.sendingAddresses,
    queryFn: ({ signal }) => getSendingAddresses(signal),
    staleTime: SENDING_ADDRESSES_STALE_TIME,
  })
}
